import {Spine, AnimationProperty} from '@gongxigames/framework/core/fragments/display';
import {iterChildren} from '@gongxigames/framework/core/fragments/BuilderY';
import {coreStore} from '@gongxigames/framework/core/globals';
import type {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';
import type {ISkeletonData} from 'pixi-spine';
import {Container} from 'pixi.js';

export class SpineComponentBase extends Spine {
    private _lastUpdateManager: UpdateManager;
    private _attachments?: Container[];

    constructor(
        spineData: ISkeletonData,
        updateManager: UpdateManager,
        initialAnimation?: AnimationProperty
    ) {
        super(spineData, initialAnimation);

        this._lastUpdateManager = updateManager;
    }

    public set updateManager(value: UpdateManager) {
        this._updateManager = value;
        this._lastUpdateManager = value || this._lastUpdateManager;
    }

    public start(): Spine {
        super.start();

        if (!this._updateManager) {
            this._lastUpdateManager.add(this);
        }

        return this;
    }

    public setAnimation(property: AnimationProperty): Spine {
        const spine = super.setAnimation(property);

        if (this._attachments) {
            this.setAttachments(this._attachments);
        }

        return spine;
    }

    public setAttachments(attachments: Container[]): void {

        this._attachments = attachments;
        const spineUtils = coreStore.spineUtils.value!;

        for (const replacement of iterChildren(attachments)) {
            const name = replacement.name as string | undefined;

            if (!name) {
                throw new Error('All slot replacements must have a name...');
            }

            spineUtils.addToSlot(this, replacement, name);
        }
    }
}